import { Navigation } from '../components/Navigation';
import { FullScreenHero } from '../components/FullScreenHero';
import { ServicesStickyScroll } from '../components/ServicesStickyScroll';
import { BenefitsStickyScroll } from '../components/BenefitsStickyScroll';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection, Footer } from '../components/CTASection';

export function LandingPage() {
  return (
    <div className="min-h-screen">
      <Navigation />
      
      <FullScreenHero />

      <ServicesStickyScroll />

      <BenefitsStickyScroll />

      <TestimonialsSection />

      <CTASection />

      <Footer />
    </div>
  );
}
